/**
 * Central registry of all persistent keys used in table configs.
 * Add new keys here to enable autocomplete and prevent typos.
 */
export const PersistentKeys = {
    ARateCardsTable: 'a-rate-cards-table',
    ARateCardsBaseLeaseTable: 'a-rate-cards-base-lease-table',
    ARateCardsAdditionalFeesTable: 'a-rate-cards-additional-fees-table',
} as const

// Map of key -> registration source (to detect true duplicates vs HMR reloads)
const keyRegistry = new Map<string, string>()

const getCallerLocation = (): string => {
    const stack = new Error().stack || ''
    // Get the caller's location (skip this function and registerPersistentKey)
    const lines = stack.split('\n')

    return lines[3] || ''
}

/**
 * Registers a persistent key and checks for duplicates.
 * Allows re-registration from same location (HMR) but warns for different locations.
 */
export const registerPersistentKey = (key: string): string => {
    const caller = getCallerLocation()
    const existingCaller = keyRegistry.get(key)

    if (existingCaller && existingCaller !== caller && process.env.NODE_ENV === 'development') {
        // eslint-disable-next-line no-alert
        alert(`Duplicate persistentKey detected: "${key}"`)
    }
    keyRegistry.set(key, caller)
    return key
}
